export type McpDraftContext = {
  datasetUuid: string | null;
  revisionUuid: string | null;
  probeUuid: string;
  sourceId: string;
  sampleSourceIds: readonly string[];
};

/** 문맥은 데이터로 직렬화한다. 토큰과 서명된 미디어 주소는 지시문에 넣지 않는다. */
export function mcpDraftPrompt(context: McpDraftContext): string {
  return [
    "spnp MCP로 아래 대상의 Revision 매핑 초안을 준비해 주세요.",
    JSON.stringify(context, null, 2),
    "mcp_usage_guide를 읽고, probe_detail로 Revision과 샘플 대상을 확인하세요.",
    "mapping_draft_start로 저장본에서 초안을 시작하고, episode_inspect로 선택 episode와 샘플의 채널 선언을 검토하세요.",
    "초안은 mapping_draft_edit로 바꿀 칸만 경로로 고치세요. 매핑 전체를 다시 쓰지 마세요. 형식은 mapping_schema에 고칠 자리의 path를 넘겨 확인하세요.",
    "원본 선언으로 확인할 수 없는 단위·자세 표현·프레임·그리퍼 범위는 추측하지 말고 빈 값과 확인할 질문으로 남겨 주세요.",
    "TCP는 v2 역할별 계약으로 작성하세요. 공식 자료의 조사 상태와 적용 범위를 남기세요. 추론 후보는 자료·다른 후보·실제 관측 구간·남은 불확실성을 보존하세요.",
    "기록된 기준점 S, Sigmakit 닫힘 TCP C, 표시 모델의 현재 파지 중심 G를 구분하세요. 메시 치수·가상 회전·POC 성공을 실제 TCP 확인 근거로 쓰지 마세요.",
    "수정 이유와 미완성 필드, 기존 저장본과의 차이를 설명하세요. 초안 digest로 mapping_save(is_temp=true) 저장 계획을 제시하고 사용자의 확인 뒤 apply하세요. apply는 change_apply에 confirmation_id만 넘깁니다.",
    "저장 후 이 화면에서 영상·3D와 대조하고 샘플 검증할 예정입니다. POC 요청과 매핑 삭제는 이 작업에 포함하지 않습니다.",
  ].join("\n\n");
}
